import { render, staticRenderFns } from "./indexHeaders.vue?vue&type=template&id=6972aa3c&scoped=true&"
import script from "./indexHeaders.vue?vue&type=script&lang=js&"
export * from "./indexHeaders.vue?vue&type=script&lang=js&"
import style0 from "./indexHeaders.vue?vue&type=style&index=0&id=6972aa3c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6972aa3c",
  null
  
)

export default component.exports